import React from 'react';
import Icon from '@/components/ui/AppIcon';

interface TimelineCardProps {
  month: string;
  title: string;
  description: string;
  iconName: string;
}

export default function TimelineCard({
  month,
  title,
  description,
  iconName,
}: TimelineCardProps) {
  return (
    <div className="bg-card rounded-xl sm:rounded-2xl p-5 sm:p-6 border border-border shadow-sm hover:shadow-md transition-shadow duration-300">
      <div className="flex items-center gap-2 sm:gap-3 mb-3 sm:mb-4">
        <div className="w-10 h-10 sm:w-12 sm:h-12 rounded-full bg-primary/10 flex items-center justify-center">
          <Icon name={iconName as any} size={20} className="text-primary sm:w-6 sm:h-6" />
        </div>
        <span className="text-xs font-mono uppercase text-muted-foreground tracking-wider">
          {month}
        </span>
      </div>
      <h3 className="text-lg sm:text-xl font-semibold text-foreground mb-2">{title}</h3>
      <p className="text-muted-foreground text-sm leading-relaxed">{description}</p>
    </div>
  );
}